export const alphaNumericRegex = /^[a-zA-ZñÑ0-9]*$/;
export const numericRegex = /^[0-9]*$/;

export const onlyNumbers = (string) => {
  if (!string) return '';
  return string.replace(/[^0-9]/g, '');
};

export const onlyLetters = (string, toUpperCase = false) => {
  if (!string) return '';
  const result = string.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
  return toUpperCase ? result.toUpperCase() : result;
};

export const isAlphanumeric = (value) => alphaNumericRegex.test(value);

export const isNumeric = (value) => numericRegex.test(value);

// Filtra un string dejando solo caracteres VIN válidos en mayúsculas.
export const onlyVIN = (value) => {
  if (!value) return '';
  return value.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '');
};
